import valueReducer from '../../../common/reducers/valueReducer';
import { SET } from './constants';

const reducer = valueReducer({ services: [], products: [] }, SET);

export default reducer;
